<template>
  <section>
    <errors-list :errorMessage="errorMessage" />

    <v-data-table
      :headers="translatedHeaders"
      :items="items"
      :loading="loading"
      :rows-per-page-items="rowsPerPageItems"
      :hide-actions="true"
      item-key="_id"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <template :header="header" :row="props.item" v-for="(header, index) in translatedHeaders">
            <td v-if="header.value === 'type'" :key="index">
              <div>{{ localizedType(props.item.type) }}</div>
            </td>
            <td v-else-if="header.value === 'comment'" :key="index + 'comment'">
              <a
                v-if="props.item.comment"
                @click="(dialog = true), (dialogMessage = props.item.comment)"
              >
                <div class="comment">
                  {{ props.item.comment }}
                </div>
              </a>
            </td>
            <td v-else-if="header.value === 'byEmployee'" :key="index + 'byEmployee'">
              <span>{{ createdBy(props.item.byEmployee) }}</span>
            </td>
            <grid-cell v-else :header="header" :row="props.item" :key="index + 'else'"></grid-cell>
          </template>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-text>
          <code class="pa-2 comment-dialog">{{ dialogMessage }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class="ma-2"
            text
            dark
            @click="(dialog = false), (dialogMessage = '')"
          >
            {{ $t('@newContractForm/close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import ErrorsList from '../../components/ErrorsList';
import GridCell from '../../components/GridCell';
import { getErrorMessage } from '../../errorHandlers';
import { defaultDateTimeFormatter, monthDateFormatter } from '../../utils';

const defaultHeaders = [
  {
    text: '@campaignsList/created',
    value: 'created',
    format: defaultDateTimeFormatter,
    sortable: false,
  },
  {
    text: '@campaignsList/type',
    value: 'type',
    sortable: false,
  },
  {
    text: '@campaignsList/name',
    value: 'name',
    sortable: false,
  },
  // {
  //   text: '@campaignsList/active',
  //   value: 'active',
  //   sortable: false,
  // },
  {
    text: '@campaignsList/firstMonth',
    value: 'firstMonth',
    format: monthDateFormatter,
    sortable: false,
  },
  {
    text: '@campaignsList/lastMonth',
    value: 'lastMonth',
    format: monthDateFormatter,
    sortable: false,
  },
  {
    text: '@auditTrailEventsList/userColumnHeader',
    value: 'byEmployee',
    sortable: false,
  },
];

export default {
  components: { GridCell, ErrorsList },

  props: {
    contract: {
      type: Object,
    },
    headers: {
      type: Array,
      default: () => defaultHeaders,
    },
  },

  watch: {},

  data() {
    return {
      lastQueryString: '',
      errorMessage: '',
      loading: false,
      items: [],
      rowsPerPageItems: [10, 15, 50, 100],
      dialog: false,
      dialogMessage: '',
    };
  },

  computed: {
    translatedHeaders() {
      return Array.isArray(this.headers)
        ? this.headers.map((h) => ({
            ...h,
            text: this.$t(h.text),
          }))
        : [];
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const { data } = await this.$http.get(`/api/insurance/${this.contract.id}/campaigns`);

        this.items = data || [];

        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },

    createdBy(user) {
      return user ? `${user.firstName} ${user.lastName}` : this.$t('@campaignsList/customer');
    },

    localizedType(type) {
      return type ? this.$t(`@campaignsList/type/${type}`) : '';
    },
  },
};
</script>

<style scoped></style>
